import { render, staticRenderFns } from "./MetaValuation.vue?vue&type=template&id=205fce3f&scoped=true&"
import script from "./MetaValuation.vue?vue&type=script&lang=ts&"
export * from "./MetaValuation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205fce3f",
  null
  
)

export default component.exports